import { atom } from "jotai";

export const alertSendEmail = atom({
   bool: false,
   status: null,
   message: null,
});
